export class LoginTextDataES {
  static readonly SEOlLabel = {
    appTitle: 'Inicio de Sesión - Plataforma de Remediación de PDF | PREP',
  };
  static readonly htmlLabel = {
    appName: 'Plataforma de Remediación de PDF',
    ssoUserLogin: 'INICIO DE SESIÓN DE USUARIO DE COLORADO SPRINGS',
    userLogin: 'INICIO DE SESIÓN',
    appWelcome: 'Bienvenido a la Consola PREP',
    requiredFieldMessage:
      'Los campos marcados con un asterisco (*) son obligatorios.',
    email: 'Correo Electrónico',
    emailError: 'Por favor, introduce tu dirección de correo electrónico',
    emailInvalidError:
      'Por favor, introduce una dirección de correo electrónico válida',
    password: 'Contraseña',
    passwordError: 'Necesitamos una contraseña para iniciar sesión',
    passwordMinLengthError:
      'La contraseña debe tener un mínimo de 6 caracteres',
    passwordHint: 'Haz clic en el ojo para alternar la visibilidad',
    rememberMe: 'Recuérdame para futuros inicios de sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    signIn: 'INICIAR SESIÓN',
    signInLoading: 'Iniciando sesión...',
    ssoSignIn: 'INICIO DE SESIÓN ÚNICO',
    ssosignInLoading: 'Iniciando sesión única...',
    privacyPolicy: 'Política de Privacidad',
    privacyPolicyHint:
      'Antes de hacer clic en Iniciar Sesión, puedes revisar nuestra empresa',
    spinnerText: 'Cargando, por favor espera...',
    poweredBy: 'Desarrollado por',
    skipToMain: 'Saltar al contenido',
  };
  static readonly snackbarLabels = {
    errorInternetConnection:
      'Error: ¡Por favor, verifica tu conexión a Internet!',
    errorLogin400:
      'Error: Inicio de sesión fallido. ¡Correo Electrónico o Contraseña incorrectos!',
    errorLogin401:
      'Error: Inicio de sesión fallido. El usuario solo puede iniciar sesión en un dispositivo.',
    SuccessSignIn:
      'Inicio de sesión exitoso. Redirigiendo al panel de control.',
  };
  static readonly tooltipLabels = {
    buttonPasswordToggle: 'Mostrar/Ocultar Contraseña',
  };
  static readonly ariaLabels = {
    main: 'Contenido de la página de inicio de sesión',
    rememberMe: 'Recuérdame para futuros inicios de sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    signIn: 'Iniciar sesión',
    signInDisabled: 'Iniciar sesión (deshabilitado o cargando)',
    signInBusy: 'Iniciar sesión (cargando en progreso)',
    showHidePassword: 'Mostrar/Ocultar',
    passwordVisibilityToggle: {
      true: 'Ocultar contraseña',
      false: 'Mostrar contraseña',
    },
    privacyNote: 'Aviso de política de privacidad',
    privacyPolicyLink:
      'Ver la Política de Privacidad de nuestra empresa en una nueva pestaña',
    loadingSpinner: 'Cargando, por favor espera',
    spinnerText: 'Cargando, por favor espera',
    loginPreferences: 'Preferencias de inicio de sesión',
    brandingSection: 'Sección de marca',
    languageSelector: 'Selector de idioma',
  };
  static readonly altLabels = {
    prepLogo: 'Logotipo de PREP',
    continualEngineLogo: 'Logotipo de Continual Engine',
  };
}

export class ForgotPasswordTextDataES {
  static readonly SEOlLabel = {
    appTitle: 'Olvidé mi Contraseña - Plataforma de Remediación de PDF | PREP',
  };
  static readonly htmlLabel = {
    appName: 'Plataforma de Remediación de PDF',
    appPagetitle: 'OLVIDÉ MI CONTRASEÑA',
    requiredFieldMessage:
      'Los campos marcados con un asterisco (*) son obligatorios.',
    email: 'Correo Electrónico',
    emailError: 'Por favor, introduce tu dirección de correo electrónico',
    emailInvalidError:
      'Por favor, introduce una dirección de correo electrónico válida',

    buttonSubmit: 'Enviar',
    buttonGoBack: 'VOLVER AL INICIO DE SESIÓN',
    privacyPolicy: 'Política de Privacidad',
    privacyPolicyHint:
      'Antes de hacer clic en Iniciar Sesión, puedes revisar nuestra empresa',
    spinnerText: 'Cargando, por favor espera...',
    poweredBy: 'Desarrollado por',
  };
  static readonly snackbarLabels = {
    errorInternetConnection:
      'Error: ¡Por favor, verifica tu conexión a Internet!',
    errorGeneric: 'Error: Algo salió mal. ¡Por favor, contacta al soporte!',
    SuccessSubmit:
      'El enlace para restablecer la contraseña ha sido enviado a tu correo electrónico. Por favor, revisa tu correo.',
  };
  static readonly ariaLabels = {
    skipLink: 'Saltar al contenido principal',
    privacyNote: 'Aviso de política de privacidad',
    privacyPolicyLink:
      'Ver la Política de Privacidad de nuestra empresa en una nueva pestaña',
    spinner: 'Cargando, por favor espera',
  };

  static readonly altLabels = {
    prepLogo: 'Logo de PREP',
    continualEngineLogo: 'Logo de Continual Engine',
  };
}

export class ResetPasswordTextDataES {
  static readonly SEOlLabel = {
    appTitle: 'Restablecer contraseña - Plataforma de remediación de PDF | PREP',
  };
  static readonly htmlLabel = {
    appName: 'Plataforma de remediación de PDF',
    resetPasswordHeading: 'RESTABLECER CONTRASEÑA',
    passwordLabel: 'Contraseña',
    toggleHint: 'Haz clic en el ojo para mostrar u ocultar la contraseña',
    resetPasswordButton: 'RESTABLECER CONTRASEÑA',
    privacyPolicy: 'Política de privacidad',
    privacyPolicyHint: 'Antes de hacer clic en Iniciar sesión, puedes consultar la información de nuestra empresa',
    spinnerText: 'Cargando, por favor espere...',
    poweredBy: 'Desarrollado por'
  };
  static readonly snackbarLabels = {
    messages: {
      success: 'Contraseña cambiada con éxito',
      error_404: '¡URL ya utilizada o caducada!',
    },
    action: 'OK GRACIAS',
  };
  static readonly tooltipLabels = {
    buttonPasswordToggle: 'Mostrar/Ocultar contraseña',
  };
  static readonly ariaLabels = {
    main: 'Contenido principal de la página Restablecer contraseña',
    resetPasswordHeading: 'Restablecer contraseña',
    togglePasswordVisibility: 'Mostrar u ocultar la contraseña',
  };
  static readonly altLabels = {
    prepLogo: 'Logo de PREP',
    continualEngineLogo: 'Logo de Continual Engine',
  };
}
